module.exports = __webpack_public_path__ + "img/discover.50f9313.png";